import { render, staticRenderFns } from "./agreement_mark_multiple.vue?vue&type=template&id=67758242&scoped=true"
import script from "./agreement_mark_multiple.vue?vue&type=script&lang=js"
export * from "./agreement_mark_multiple.vue?vue&type=script&lang=js"
import style0 from "./agreement_mark_multiple.vue?vue&type=style&index=0&id=67758242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67758242",
  null
  
)

export default component.exports